import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { focusOutline } from "../../../theme/src";
import { NavLinkSimple } from './NavLinkSimple';
import { getLinkStyle, ignoredPropsConfig } from '../style';
export const NavLink = (_a) => {
    var { enableWrap = false, styledOnlyOnHover = false } = _a, otherProps = __rest(_a, ["enableWrap", "styledOnlyOnHover"]);
    return (_jsx(NavLinkWrapper, Object.assign({ enableWrap: enableWrap, styledOnlyOnHover: styledOnlyOnHover }, otherProps)));
};
const NavLinkWrapper = styled(NavLinkSimple).withConfig(ignoredPropsConfig) `
  ${getLinkStyle};
  ${focusOutline};
`;
//# sourceMappingURL=NavLink.js.map